import { render, staticRenderFns } from "./aiBuild.vue?vue&type=template&id=68f5212d&scoped=true"
import script from "./aiBuild.vue?vue&type=script&lang=js"
export * from "./aiBuild.vue?vue&type=script&lang=js"
import style0 from "./aiBuild.vue?vue&type=style&index=0&id=68f5212d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5212d",
  null
  
)

export default component.exports